module.exports = __webpack_public_path__ + "static/img/lcrmyy.dd42097.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/lcrmyy.png
// module id = PB4L
// module chunks = 0